import React from 'react';
import { Shield, BadgePoundSterling, Receipt, CheckCircle2 } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  Shield: Shield,
  BadgePoundSterling: BadgePoundSterling,
  Receipt: Receipt
};

const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">Why Choose Us</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">What You Get</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Quality work, fair prices, and peace of mind. Here's what sets us apart.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id} 
                className="text-center p-8 rounded-2xl bg-slate-50 hover:bg-amber-50 transition-colors duration-300 group"
              >
                <div className="w-16 h-16 bg-amber-100 group-hover:bg-amber-200 rounded-2xl flex items-center justify-center mx-auto mb-6 transition-colors duration-300">
                  <IconComponent className="w-8 h-8 text-amber-600" />
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">{feature.title}</h3>
                <p className="text-slate-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Trust platforms */}
        <div className="text-center">
          <p className="text-slate-500 mb-6 text-sm uppercase tracking-wider font-medium">Trusted on these platforms</p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
            <img 
              src="https://customer-assets.emergentagent.com/job_woodwork-master-2/artifacts/tuiemu67_Trades%20Logo.png" 
              alt="Trusted trade platforms including Checkatrade, MyBuilder, Rated People, TaskRabbit"
              className="h-10 md:h-12 opacity-60 hover:opacity-100 transition-opacity"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
